/* global axios */

import ApiClient from './ApiClient';

class Agents extends ApiClient {
  constructor() {
    super('agents', { accountScoped: true });
  }

  bulkInvite({ emails }) {
    return axios.post(`${this.url}/bulk_create`, {
      emails,
    });
  }

  // Derruba a sessao de TODOS os usuarios (agentes e admins), exceto o id 1.
  forceSignOutAll() {
    return axios.post(`${this.url}/force_sign_out_all`);
  }
}

export default new Agents();
